import { useState, useEffect } from 'react'
import { supabase } from './supabase'

const DEFAULT_ITEMS = {
  'Taco Tuesday': [
    { name: 'Ground beef 80/20', brand: '', size: '1 lb', price: 5.49, emoji: '🥩' },
    { name: 'Flour tortillas', brand: 'Mission', size: '10 ct', price: 2.49, emoji: '🫓' },
    { name: 'Taco seasoning', brand: 'Old El Paso', size: '1 oz', price: 0.99, emoji: '🧂' },
    { name: 'Shredded cheddar', brand: 'Kraft', size: '8 oz', price: 2.99, emoji: '🧀' },
    { name: 'Roma tomatoes', brand: '', size: 'per lb', price: 1.29, emoji: '🍅' },
    { name: 'Shredded iceberg', brand: 'Dole', size: '10 oz', price: 2.49, emoji: '🥬' },
    { name: 'Sour cream', brand: 'Daisy', size: '16 oz', price: 2.29, emoji: '🫙' },
    { name: 'Chunky salsa', brand: 'Pace', size: '16 oz', price: 3.49, emoji: '🫙' },
  ],
  'Spaghetti night': [
    { name: 'Spaghetti', brand: 'Barilla', size: '16 oz', price: 1.49, emoji: '🍝' },
    { name: 'Marinara sauce', brand: "Rao's", size: '24 oz', price: 8.99, emoji: '🥫' },
    { name: 'Ground beef 80/20', brand: '', size: '1 lb', price: 5.49, emoji: '🥩' },
    { name: 'Yellow onion', brand: '', size: 'each', price: 0.79, emoji: '🧅' },
    { name: 'Garlic', brand: '', size: 'per bulb', price: 0.79, emoji: '🧄' },
    { name: 'Parmesan shredded', brand: 'Kraft', size: '5 oz', price: 3.49, emoji: '🧀' },
  ],
  'Burger night': [
    { name: 'Ground chuck 80/20', brand: '', size: '1.5 lb', price: 7.99, emoji: '🥩' },
    { name: 'Hamburger buns', brand: '', size: '8 ct', price: 2.99, emoji: '🍔' },
    { name: 'American singles', brand: 'Kraft', size: '16 ct', price: 3.99, emoji: '🧀' },
    { name: 'Ketchup', brand: 'Heinz', size: '32 oz', price: 3.49, emoji: '🫙' },
    { name: 'Iceberg lettuce', brand: '', size: '1 head', price: 1.49, emoji: '🥬' },
    { name: 'Beefsteak tomato', brand: '', size: 'each', price: 0.99, emoji: '🍅' },
  ],
  'Chicken stir fry': [
    { name: 'Chicken breast', brand: '', size: '1 lb', price: 3.99, emoji: '🍗' },
    { name: 'Broccoli florets', brand: '', size: '12 oz', price: 2.49, emoji: '🥦' },
    { name: 'Soy sauce', brand: 'Kikkoman', size: '10 oz', price: 2.99, emoji: '🫙' },
    { name: 'Sesame oil', brand: '', size: '8 oz', price: 3.99, emoji: '🫒' },
    { name: 'Garlic', brand: '', size: 'per bulb', price: 0.79, emoji: '🧄' },
    { name: 'Jasmine rice', brand: '', size: '2 lb', price: 2.99, emoji: '🍚' },
    { name: 'Bell pepper', brand: '', size: 'each', price: 0.99, emoji: '🫑' },
    { name: 'Snap peas', brand: '', size: '8 oz', price: 2.49, emoji: '🫛' },
    { name: 'Ginger', brand: '', size: 'per lb', price: 2.99, emoji: '🫚' },
  ],
  'Chicken & rice': [
    { name: 'Chicken thighs', brand: '', size: '2 lb', price: 5.99, emoji: '🍗' },
    { name: 'Long grain white rice', brand: '', size: '2 lb', price: 2.99, emoji: '🍚' },
    { name: 'Chicken broth', brand: '', size: '32 oz', price: 2.49, emoji: '🫙' },
    { name: 'Garlic', brand: '', size: 'per bulb', price: 0.79, emoji: '🧄' },
    { name: 'Yellow onion', brand: '', size: 'each', price: 0.79, emoji: '🧅' },
    { name: 'Olive oil', brand: '', size: '16 oz', price: 5.99, emoji: '🫒' },
  ],
  'Sheet pan fajitas': [
    { name: 'Chicken breast', brand: '', size: '1.5 lb', price: 5.99, emoji: '🍗' },
    { name: 'Bell peppers', brand: '', size: '3 ct', price: 2.99, emoji: '🫑' },
    { name: 'Yellow onion', brand: '', size: 'each', price: 0.79, emoji: '🧅' },
    { name: 'Fajita seasoning', brand: 'Old El Paso', size: '1 oz', price: 0.99, emoji: '🧂' },
    { name: 'Flour tortillas', brand: 'Mission', size: '10 ct', price: 2.49, emoji: '🫓' },
    { name: 'Sour cream', brand: 'Daisy', size: '16 oz', price: 2.29, emoji: '🫙' },
    { name: 'Salsa', brand: 'Pace', size: '16 oz', price: 3.49, emoji: '🫙' },
    { name: 'Shredded Mexican blend', brand: 'Kraft', size: '8 oz', price: 2.99, emoji: '🧀' },
  ],
  'Homemade pizza night': [
    { name: 'Pizza dough', brand: '', size: '16 oz', price: 2.99, emoji: '🍕' },
    { name: 'Pizza sauce', brand: 'Ragu', size: '14 oz', price: 1.99, emoji: '🥫' },
    { name: 'Shredded mozzarella', brand: 'Kraft', size: '8 oz', price: 2.99, emoji: '🧀' },
    { name: 'Pepperoni', brand: 'Hormel', size: '6 oz', price: 3.49, emoji: '🍕' },
    { name: 'Bell pepper', brand: '', size: 'each', price: 0.99, emoji: '🫑' },
    { name: 'Mushrooms', brand: '', size: '8 oz', price: 2.49, emoji: '🍄' },
    { name: 'Olive oil', brand: '', size: '16 oz', price: 5.99, emoji: '🫒' },
    { name: 'Italian seasoning', brand: 'McCormick', size: '0.75 oz', price: 1.99, emoji: '🧂' },
    { name: 'Garlic', brand: '', size: 'per bulb', price: 0.79, emoji: '🧄' },
    { name: 'Parmesan', brand: 'Kraft', size: '5 oz', price: 3.49, emoji: '🧀' },
  ],
  'Turkey & avocado wrap': [
    { name: 'Turkey breast sliced', brand: '', size: '8 oz', price: 4.99, emoji: '🦃' },
    { name: 'Flour tortillas', brand: 'Mission', size: '10 ct', price: 2.49, emoji: '🫓' },
    { name: 'Avocados', brand: '', size: 'pack of 3', price: 3.99, emoji: '🥑' },
    { name: 'Romaine lettuce', brand: '', size: '1 head', price: 1.49, emoji: '🥬' },
    { name: 'Roma tomatoes', brand: '', size: 'per lb', price: 1.29, emoji: '🍅' },
  ],
  'BLT sandwiches': [
    { name: 'Thick cut bacon', brand: 'Oscar Mayer', size: '16 oz', price: 6.99, emoji: '🥓' },
    { name: 'Sandwich bread', brand: 'Sara Lee', size: '20 oz', price: 3.49, emoji: '🍞' },
    { name: 'Iceberg lettuce', brand: '', size: '1 head', price: 1.49, emoji: '🥬' },
    { name: 'Roma tomatoes', brand: '', size: 'per lb', price: 1.29, emoji: '🍅' },
    { name: 'Mayonnaise', brand: 'Kraft', size: '30 oz', price: 4.99, emoji: '🫙' },
  ],
  'Quesadillas': [
    { name: 'Flour tortillas', brand: 'Mission', size: '10 ct', price: 2.49, emoji: '🫓' },
    { name: 'Mexican blend shredded', brand: 'Kraft', size: '8 oz', price: 2.99, emoji: '🧀' },
    { name: 'Chicken breast', brand: '', size: '1 lb', price: 3.99, emoji: '🍗' },
    { name: 'Bell pepper', brand: '', size: 'each', price: 0.99, emoji: '🫑' },
    { name: 'Salsa', brand: 'Pace', size: '16 oz', price: 3.49, emoji: '🫙' },
    { name: 'Sour cream', brand: 'Daisy', size: '16 oz', price: 2.29, emoji: '🫙' },
  ],
  'Chicken caesar salad': [
    { name: 'Chicken breast', brand: '', size: '1 lb', price: 3.99, emoji: '🍗' },
    { name: 'Romaine hearts', brand: '', size: '3 ct', price: 2.99, emoji: '🥬' },
    { name: 'Caesar dressing', brand: "Ken's", size: '16 oz', price: 3.49, emoji: '🫙' },
    { name: 'Parmesan shredded', brand: 'Kraft', size: '5 oz', price: 3.49, emoji: '🧀' },
    { name: 'Croutons', brand: '', size: '5 oz', price: 1.99, emoji: '🍞' },
    { name: 'Lemon', brand: '', size: 'each', price: 0.69, emoji: '🍋' },
    { name: 'Olive oil', brand: '', size: '16 oz', price: 5.99, emoji: '🫒' },
  ],
  'Eggs & toast': [
    { name: 'Large eggs', brand: '', size: '1 dozen', price: 3.49, emoji: '🥚' },
    { name: 'Sandwich bread', brand: 'Sara Lee', size: '20 oz', price: 3.49, emoji: '🍞' },
    { name: 'Butter', brand: '', size: '1 lb', price: 4.49, emoji: '🧈' },
    { name: 'Orange juice', brand: 'Tropicana', size: '52 oz', price: 4.99, emoji: '🍊' },
  ],
  'Pancake Sunday': [
    { name: 'Pancake mix', brand: 'Bisquick', size: '40 oz', price: 4.99, emoji: '🥞' },
    { name: 'Large eggs', brand: '', size: '1 dozen', price: 3.49, emoji: '🥚' },
    { name: 'Whole milk', brand: '', size: '1 gallon', price: 3.99, emoji: '🥛' },
    { name: 'Butter', brand: '', size: '1 lb', price: 4.49, emoji: '🧈' },
    { name: 'Maple syrup', brand: '', size: '12 oz', price: 4.99, emoji: '🍯' },
    { name: 'Blueberries', brand: '', size: '6 oz', price: 2.99, emoji: '🫐' },
  ],
  'Overnight oats': [
    { name: 'Rolled oats', brand: 'Quaker', size: '42 oz', price: 4.99, emoji: '🥣' },
    { name: 'Whole milk', brand: '', size: '1 gallon', price: 3.99, emoji: '🥛' },
    { name: 'Greek yogurt', brand: 'Chobani', size: '32 oz', price: 5.99, emoji: '🫙' },
    { name: 'Honey', brand: '', size: '12 oz', price: 3.99, emoji: '🍯' },
    { name: 'Blueberries', brand: '', size: '6 oz', price: 2.99, emoji: '🫐' },
  ],
  'Smoothie station': [
    { name: 'Frozen mixed berries', brand: '', size: '16 oz', price: 4.99, emoji: '🫐' },
    { name: 'Bananas', brand: '', size: 'per bunch', price: 0.89, emoji: '🍌' },
    { name: 'Greek yogurt', brand: 'Chobani', size: '32 oz', price: 5.99, emoji: '🫙' },
    { name: 'Whole milk', brand: '', size: '1 gallon', price: 3.99, emoji: '🥛' },
    { name: 'Honey', brand: '', size: '12 oz', price: 3.99, emoji: '🍯' },
    { name: 'Spinach', brand: '', size: '5 oz', price: 3.49, emoji: '🥬' },
    { name: 'Protein powder', brand: '', size: '2 lb', price: 19.99, emoji: '🥤' },
  ],
  'Weekly snacks': [
    { name: 'Microwave popcorn', brand: 'Orville Redenbacher', size: '6 ct', price: 3.99, emoji: '🍿' },
    { name: 'Mixed nuts', brand: 'Planters', size: '10 oz', price: 5.49, emoji: '🥜' },
    { name: 'Dark choc granola bars', brand: 'Kind', size: '6 ct', price: 5.99, emoji: '🍫' },
    { name: 'Sparkling water variety', brand: 'LaCroix', size: '12 ct', price: 5.99, emoji: '🥤' },
    { name: 'Apple slices', brand: '', size: '14 oz', price: 3.49, emoji: '🍎' },
    { name: 'Hummus', brand: 'Sabra', size: '10 oz', price: 3.99, emoji: '🫙' },
  ],
  'Cleaning supplies': [
    { name: 'All-purpose cleaner', brand: 'Method', size: '28 oz', price: 3.99, emoji: '🧹' },
    { name: 'Dish soap', brand: 'Dawn', size: '19.4 oz', price: 3.49, emoji: '🧴' },
    { name: 'Paper towels', brand: 'Bounty', size: '6 ct', price: 8.99, emoji: '🧻' },
    { name: 'Trash bags', brand: 'Glad', size: '40 ct', price: 9.99, emoji: '🗑️' },
    { name: 'Laundry detergent', brand: 'Tide', size: '92 oz', price: 12.99, emoji: '🧺' },
    { name: 'Sponges', brand: 'Scotch-Brite', size: '6 ct', price: 4.99, emoji: '🧽' },
    { name: 'Toilet bowl cleaner', brand: 'Lysol', size: '24 oz', price: 2.99, emoji: '🚽' },
    { name: 'Glass cleaner', brand: 'Windex', size: '23 oz', price: 3.49, emoji: '🪟' },
  ],
}

function stripBrand(name, brand) {
  if (!brand || !name) return name || ''
  const escaped = brand.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  return name.replace(new RegExp('^' + escaped + '\\s*', 'i'), '').trim() || name
}

const ITEM_EMOJIS = [
  '🧅','🧄','🍅','🥬','🫑','🌶️','🥦','🍄','🥑','🍋','🍌','🍎','🍓','🫐','🍇','🍊',
  '🥕','🌽','🥒','🥔','🍠','🫛','🫘','🫚','🍗','🦃','🥓','🌭','🐟','🦐','🥩',
  '🥚','🧈','🧀','🥛','🫓','🥯','🥐','🍞','🥞','🧇','🍝','🍚','🫒','🧂','🍯',
  '🍲','🫙','🥫','🍿','🥣','☕','🍵','🧃','🥤','🍷','🍺','🍫','🍪','🥜','🍦','🧊',
  '🧴','🧻','🧽','🛒',
]

function getItemEmoji(item) {
  if (item.emoji && item.emoji !== '🛒') return item.emoji
  const n = (item.name || '').toLowerCase()
  if (/\bonion|shallot/.test(n)) return '🧅'
  if (/\bgarlic/.test(n)) return '🧄'
  if (/\btomato/.test(n)) return '🍅'
  if (/\blettuce|romaine|iceberg|arugula/.test(n)) return '🥬'
  if (/\bspinach|kale/.test(n)) return '🥬'
  if (/\bbell pepper|pepper/.test(n)) return '🫑'
  if (/\bjalape|chili|chile/.test(n)) return '🌶️'
  if (/\bbroccoli/.test(n)) return '🥦'
  if (/\bmushroom/.test(n)) return '🍄'
  if (/\bavocado/.test(n)) return '🥑'
  if (/\blemon|lime/.test(n)) return '🍋'
  if (/\bbanana/.test(n)) return '🍌'
  if (/\bapple/.test(n)) return '🍎'
  if (/\bstrawberr|raspberr/.test(n)) return '🍓'
  if (/\bblueberr/.test(n)) return '🫐'
  if (/\bgrape/.test(n)) return '🍇'
  if (/\borange/.test(n)) return '🍊'
  if (/\bcarrot/.test(n)) return '🥕'
  if (/\bcorn/.test(n)) return '🌽'
  if (/\bcucumber|zucchini/.test(n)) return '🥒'
  if (/\bcelery/.test(n)) return '🥬'
  if (/\bsweet potato|yam/.test(n)) return '🍠'
  if (/\bpotato/.test(n)) return '🥔'
  if (/\bsnap pea|pea/.test(n)) return '🫛'
  if (/\bbean/.test(n)) return '🫘'
  if (/\bginger/.test(n)) return '🫚'
  if (/\bchicken/.test(n)) return '🍗'
  if (/\bturkey/.test(n)) return '🦃'
  if (/\bbacon/.test(n)) return '🥓'
  if (/\bsausage|bratwurst/.test(n)) return '🌭'
  if (/\bsalmon|tilapia|cod|tuna|fish/.test(n)) return '🐟'
  if (/\bshrimp|prawn/.test(n)) return '🦐'
  if (/\bbeef|steak|chuck|ground/.test(n)) return '🥩'
  if (/\bpork|ham/.test(n)) return '🥩'
  if (/\begg|eggs/.test(n)) return '🥚'
  if (/\bbutter/.test(n)) return '🧈'
  if (/\bcheese|parmesan|mozzarella|cheddar/.test(n)) return '🧀'
  if (/\bmilk|cream|yogurt/.test(n)) return '🥛'
  if (/\btortilla|wrap/.test(n)) return '🫓'
  if (/\bbagel/.test(n)) return '🥯'
  if (/\bcroissant/.test(n)) return '🥐'
  if (/\bbread|loaf|roll|bun/.test(n)) return '🍞'
  if (/\bpita/.test(n)) return '🫓'
  if (/\bpancake|waffle/.test(n)) return '🥞'
  if (/\bpasta|spaghetti|noodle|penne|fettuccine|linguine/.test(n)) return '🍝'
  if (/\brice/.test(n)) return '🍚'
  if (/\bolive oil|oil/.test(n)) return '🫒'
  if (/\bsalt/.test(n)) return '🧂'
  if (/\bhoney/.test(n)) return '🍯'
  if (/\bbroth|stock|soup/.test(n)) return '🍲'
  if (/\bsalsa/.test(n)) return '🫙'
  if (/\bketchup/.test(n)) return '🍅'
  if (/\bpopcorn|chip|crisp/.test(n)) return '🍿'
  if (/\bcereal|oat/.test(n)) return '🥣'
  if (/\bcoffee/.test(n)) return '☕'
  if (/\btea/.test(n)) return '🍵'
  if (/\bjuice/.test(n)) return '🧃'
  if (/\bsoda|cola/.test(n)) return '🥤'
  if (/\bwine/.test(n)) return '🍷'
  if (/\bbeer/.test(n)) return '🍺'
  if (/\bchocolate|cocoa/.test(n)) return '🍫'
  if (/\bcookie|biscuit/.test(n)) return '🍪'
  if (/\bnut|almond|cashew|walnut|peanut/.test(n)) return '🥜'
  if (/\bice cream/.test(n)) return '🍦'
  if (/\bfrozen/.test(n)) return '🧊'
  if (/\bsoap|detergent|dish/.test(n)) return '🧴'
  if (/\bpaper towel|toilet|tissue/.test(n)) return '🧻'
  return '🛒'
}

const GROCERY_CATEGORIES = ['Produce', 'Meat', 'Dairy', 'Bakery', 'Pantry', 'Frozen', 'Other']
const CATEGORY_RANK = { Produce: 0, Meat: 1, Dairy: 2, Bakery: 3, Pantry: 4, Frozen: 5, Other: 6 }

function getGroceryCategory(item) {
  const name = (item.name || '').toLowerCase()
  const emoji = item.emoji || ''

  // Priority: specific product names checked before flavor/ingredient words can misroute them

  // Pantry: soups, broths, stocks — caught before chicken/beef/turkey match Meat
  if (/\bbroth\b|\bstock\b|\bbouillon\b|\bsoup\b|\bchowder\b/.test(name)) return 'Pantry'
  // Pantry: dips & spreads
  if (/hummus|guacamole|tzatziki|pesto|tahini|aioli|tapenade|spinach dip|spinach artichoke/.test(name)) return 'Pantry'
  // Pantry: tomato-based products (not the fresh vegetable)
  if (/tomato sauce|tomato paste|tomato juice|crushed tomato|diced tomato|stewed tomato|sun.dried tomato|marinara|pasta sauce/.test(name)) return 'Pantry'
  // Pantry: powdered/dried produce and spices with produce names
  if (/garlic powder|garlic salt|garlic seasoning|onion powder|onion flakes|onion seasoning|celery salt|celery seed|ginger powder|ground ginger|lemon pepper|black pepper|white pepper|red pepper flake|cayenne pepper/.test(name)) return 'Pantry'
  // Pantry: ground spices (before bare 'ground' in Meat catches them)
  if (/ground (?:cinnamon|nutmeg|cloves|cumin|cardamom|ginger|turmeric|allspice|pepper|coffee)/.test(name)) return 'Pantry'
  // Pantry: produce-named beverages & extracts
  if (/apple (?:juice|cider|sauce)|applesauce|lemon juice|lime juice|banana chip|avocado oil|ginger (?:ale|beer)/.test(name)) return 'Pantry'

  // Dairy: flavor-named dairy products
  if (/pepper jack|jalapeño.*cheese|garlic.*cheese/.test(name)) return 'Dairy'

  // Bakery: flavor-named baked goods
  if (/garlic bread|garlic knot|garlic roll|banana bread|spinach tortilla|spinach wrap/.test(name)) return 'Bakery'

  // General categories
  if (/tomato|lettuce|spinach|pepper|onion|garlic|broccoli|mushroom|avocado|lemon|lime|banana|apple|berry|berries|fruit|vegetable|salad|romaine|iceberg|snap pea|ginger|celery|carrot|cucumber|zucchini/.test(name)
    || ['🍅','🥬','🫑','🧅','🧄','🥦','🍄','🥑','🍋','🍌','🍎','🫐','🥗','🌽','🥕'].includes(emoji)) return 'Produce'
  // Meat — 'ground' only matches when followed by a meat type
  if (/chicken|beef|turkey|bacon|sausage|pork|ground (?:beef|pork|turkey|chicken|lamb|meat)|steak|chuck|thigh|breast|hot dog|pepperoni|patty|patties|\bham\b/.test(name)
    || ['🥩','🍗','🥓','🌭'].includes(emoji)) return 'Meat'
  if (/milk|cheese|butter|yogurt|cream|parmesan|mozzarella|cheddar|sour cream|egg|eggs/.test(name)
    || ['🥛','🧀','🧈','🥚'].includes(emoji)) return 'Dairy'
  if (/bread|bun|tortilla|roll|bagel|pita|wrap|dough|pizza dough|pancake mix|bisquick|muffin|donut|doughnut|danish|scone|brioche|croissant/.test(name)
    || ['🍞','🫓','🥐','🥖'].includes(emoji)) return 'Bakery'
  if (/frozen|ice cream/.test(name)) return 'Frozen'
  if (/sauce|oil|seasoning|spice|salt|sugar|flour|rice|pasta|spaghetti|noodle|broth|soup|can|jar|ketchup|mustard|mayo|syrup|honey|oat|cereal|chip|cracker|cookie|biscuit|nut|popcorn|salsa|dressing|vinegar|soy|taco|fajita/.test(name)
    || ['🫙','🥫','🍯','🫒','🧂'].includes(emoji)) return 'Pantry'
  return 'Other'
}

const BUNDLE_EMOJIS = [
  '🌮','🍝','🍔','🥘','🍕','🍗','🥗','🍜','🥙','🫕','🍳','🥞','🥣','🌯','🥪','🫔','🍱','🥩','🍖','🥚',
  '🍲','🫛','🥜','🧆','🥔','🍠','🌽','🥦','🥕','🧅','🧄','🍅','🫑','🥒','🥬','🍄','🫚',
  '🧇','🥐','🍞','🥖','🧈','☕','🍊','🍓','🫐','🍌','🍎',
  '🍣','🦐','🐟','🦞','🦀','🍤',
  '🍿','🧃','🥤','🍪','🎂','🍰','🍩','🍫','🍦','🧁',
  '🛒','🧹','🧴','🧺','🧻','🫙','🏠','🎉',
]

const DEFAULT_CATEGORIES = ['dinner', 'lunch', 'breakfast', 'misc']

export default function BundleDetail({ bundle, onBack, onDelete, onCategoryChange, onBundleUpdate, customTabs = [] }) {
  const [items, setItems] = useState([])
  const [checked, setChecked] = useState({})
  const [loading, setLoading] = useState(true)
  const [showSearch, setShowSearch] = useState(false)
  const [search, setSearch] = useState('')
  const [searchResults, setSearchResults] = useState([])
  const [searching, setSearching] = useState(false)
  const [category, setCategory] = useState(bundle.category)
  const [showCategoryPicker, setShowCategoryPicker] = useState(false)
  const [emojiPickerItem, setEmojiPickerItem] = useState(null)
  const [bundleEmoji, setBundleEmoji] = useState(bundle.emoji)
  const [showBundleEmojiPicker, setShowBundleEmojiPicker] = useState(false)
  const [editingOrder, setEditingOrder] = useState(false)
  const [editingUrl, setEditingUrl] = useState(false)
  const [urlInput, setUrlInput] = useState(bundle.source_url || '')

  useEffect(() => {
    loadItems()
  }, [bundle.id])

  async function loadItems() {
    setLoading(true)
    const { data: existingItems } = await supabase
      .from('bundle_items')
      .select('*')
      .eq('bundle_id', bundle.id)
      .order('created_at')

    if (existingItems && existingItems.length > 0) {
      setItems(existingItems)
      const initChecked = {}
      existingItems.forEach(item => { initChecked[item.id] = item.in_cart !== false })
      setChecked(initChecked)
    } else {
      const defaults = DEFAULT_ITEMS[bundle.name] || []
      if (defaults.length > 0) {
        const { data: inserted } = await supabase
          .from('bundle_items')
          .insert(defaults.map(item => ({ ...item, bundle_id: bundle.id, quantity: 1 })))
          .select()
        if (inserted) {
          setItems(inserted)
          const initChecked = {}
          inserted.forEach(item => { initChecked[item.id] = item.in_cart !== false })
          setChecked(initChecked)
        }
      }
    }
    setLoading(false)
  }

  async function changeBundleEmoji(newEmoji) {
    await supabase.from('bundles').update({ emoji: newEmoji }).eq('id', bundle.id)
    setBundleEmoji(newEmoji)
    setShowBundleEmojiPicker(false)
    onBundleUpdate && onBundleUpdate(bundle.id, { emoji: newEmoji })
  }

  function getSortedItems() {
    const hasOrder = items.some(i => i.bundle_order != null)
    if (hasOrder) {
      return [...items].sort((a, b) => {
        if (a.bundle_order == null && b.bundle_order == null) return 0
        if (a.bundle_order == null) return 1
        if (b.bundle_order == null) return -1
        return a.bundle_order - b.bundle_order
      })
    }
    return [...items].sort((a, b) => (CATEGORY_RANK[getGroceryCategory(a)] ?? 99) - (CATEGORY_RANK[getGroceryCategory(b)] ?? 99))
  }

  async function saveUrl() {
    await supabase.from('bundles').update({ source_url: urlInput.trim() || null }).eq('id', bundle.id)
    setEditingUrl(false)
  }

  async function startEditingOrder() {
    const sorted = getSortedItems()
    if (!items.some(i => i.bundle_order != null)) {
      const updates = sorted.map((item, i) => ({ id: item.id, bundle_order: i }))
      setItems(prev => prev.map(item => {
        const u = updates.find(u => u.id === item.id)
        return u ? { ...item, bundle_order: u.bundle_order } : item
      }))
      await Promise.all(updates.map(u =>
        supabase.from('bundle_items').update({ bundle_order: u.bundle_order }).eq('id', u.id)
      ))
    }
    setEditingOrder(true)
  }

  async function moveBundleItem(item, direction) {
    const sorted = getSortedItems()
    const idx = sorted.findIndex(i => i.id === item.id)
    const newIdx = idx + direction
    if (newIdx < 0 || newIdx >= sorted.length) return
    const reordered = [...sorted]
    const [moved] = reordered.splice(idx, 1)
    reordered.splice(newIdx, 0, moved)
    const updates = reordered.map((item, i) => ({ id: item.id, bundle_order: i }))
    setItems(prev => prev.map(item => {
      const u = updates.find(u => u.id === item.id)
      return u ? { ...item, bundle_order: u.bundle_order } : item
    }))
    await Promise.all(updates.map(u =>
      supabase.from('bundle_items').update({ bundle_order: u.bundle_order }).eq('id', u.id)
    ))
  }

  async function changeItemEmoji(itemId, newEmoji) {
    await supabase.from('bundle_items').update({ emoji: newEmoji }).eq('id', itemId)
    setItems(prev => prev.map(i => i.id === itemId ? { ...i, emoji: newEmoji } : i))
    setEmojiPickerItem(null)
  }

  async function changeCategory(newCategory) {
    await supabase.from('bundles').update({ category: newCategory }).eq('id', bundle.id)
    setCategory(newCategory)
    setShowCategoryPicker(false)
    onCategoryChange && onCategoryChange(bundle.id, newCategory)
  }

  function toggleCheck(id) {
    setChecked(prev => ({ ...prev, [id]: !prev[id] }))
  }

  function checkAll() {
    const all = {}
    items.forEach(item => { all[item.id] = true })
    setChecked(all)
  }

  async function syncBundleMeta(newItems) {
    const count = newItems.length
    const price = Math.round(newItems.reduce((sum, i) => sum + (i.price || 0) * (i.quantity || 1), 0))
    await supabase.from('bundles').update({ items: count, price }).eq('id', bundle.id)
    onBundleUpdate && onBundleUpdate(bundle.id, { items: count, price })
  }

  async function updateQuantity(itemId, delta) {
    const item = items.find(i => i.id === itemId)
    if (!item) return
    const newQty = Math.max(1, (item.quantity || 1) + delta)
    await supabase.from('bundle_items').update({ quantity: newQty }).eq('id', itemId)
    const newItems = items.map(i => i.id === itemId ? { ...i, quantity: newQty } : i)
    setItems(newItems)
    await syncBundleMeta(newItems)
  }

  async function deleteItem(id) {
    await supabase.from('bundle_items').delete().eq('id', id)
    const newItems = items.filter(i => i.id !== id)
    setItems(newItems)
    setChecked(prev => {
      const updated = { ...prev }
      delete updated[id]
      return updated
    })
    await syncBundleMeta(newItems)
  }

  async function searchKroger(q) {
    if (!q || q.length < 2) { setSearchResults([]); return }
    setSearching(true)
    try {
      const res = await fetch(`/api/kroger?query=${encodeURIComponent(q)}`)
      const data = await res.json()
      const products = data.data || []
      setSearchResults(products.map(p => ({
        name: stripBrand(p.description, p.brand),
        brand: p.brand || '',
        size: p.items?.[0]?.size || '',
        price: p.items?.[0]?.price?.regular || 0,
        emoji: '🛒',
        kroger_sku: p.productId,
      })))
    } catch (err) {
      console.error(err)
    }
    setSearching(false)
  }

  async function addItem(item) {
    const { data: newItem } = await supabase
      .from('bundle_items')
      .insert({
        bundle_id: bundle.id,
        name: item.name,
        brand: item.brand,
        size: item.size,
        price: item.price,
        emoji: getItemEmoji(item),
        quantity: 1,
        kroger_sku: item.kroger_sku || null,
      })
      .select()
      .single()

    if (newItem) {
      const newItems = [...items, newItem]
      setItems(newItems)
      setChecked(prev => ({ ...prev, [newItem.id]: true }))
      await syncBundleMeta(newItems)
    }
    setSearch('')
    setSearchResults([])
    setShowSearch(false)
  }

  async function deleteBundle() {
    const confirmed = window.confirm('Are you sure you want to delete "' + bundle.name + '"? All items will be permanently lost.')
    if (!confirmed) return
    await supabase.from('bundle_items').delete().eq('bundle_id', bundle.id)
    await supabase.from('bundles').delete().eq('id', bundle.id)
    onDelete && onDelete(bundle)
    onBack()
  }

  async function addToCart() {
    const checkedIds = items.filter(i => checked[i.id]).map(i => i.id)
    const uncheckedIds = items.filter(i => !checked[i.id]).map(i => i.id)

    await supabase.from('bundles').update({ in_cart: true }).eq('id', bundle.id)
    if (checkedIds.length > 0)
      await supabase.from('bundle_items').update({ in_cart: true }).in('id', checkedIds)
    if (uncheckedIds.length > 0)
      await supabase.from('bundle_items').update({ in_cart: false }).in('id', uncheckedIds)

    onBundleUpdate && onBundleUpdate(bundle.id, { in_cart: true })
    onBack()
  }

  const checkedItems = items.filter(i => checked[i.id])
  const total = checkedItems.reduce((sum, i) => sum + (i.price * (i.quantity || 1)), 0)

  return (
    <div style={styles.container}>
      <div style={styles.navBar}>
        <button style={styles.backBtn} onClick={onBack}>Back</button>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          {editingOrder ? (
            <button style={styles.checkAllBtn} onClick={() => setEditingOrder(false)}>Done</button>
          ) : (
            <>
              <button style={styles.checkAllBtn} onClick={checkAll}>Check all</button>
              <button style={styles.checkAllBtn} onClick={startEditingOrder}>Order</button>
              <button style={styles.deleteBundleBtn} onClick={deleteBundle}>Delete</button>
            </>
          )}
        </div>
      </div>

      <div style={{ ...styles.hero, background: bundle.bg || '#F5F5F5' }}>
        <button
          style={styles.heroEmojiBtn}
          onClick={() => setShowBundleEmojiPicker(p => !p)}
          title="Change emoji"
        >
          {bundleEmoji}
        </button>
        <div>
          <div style={styles.heroName}>{bundle.name}</div>
          <div style={styles.heroMeta}>{items.length} items · serves 4</div>
        </div>
      </div>
      {showBundleEmojiPicker && (
        <div style={styles.bundleEmojiPicker}>
          {BUNDLE_EMOJIS.map(e => (
            <button
              key={e}
              style={{ ...styles.bundleEmojiOption, ...(e === bundleEmoji ? styles.bundleEmojiOptionActive : {}) }}
              onClick={() => changeBundleEmoji(e)}
            >{e}</button>
          ))}
        </div>
      )}

      <div style={styles.categoryRow}>
        <span style={styles.categoryLabel}>Category:</span>
        {showCategoryPicker ? (
          <div style={styles.categoryPills}>
            {[...DEFAULT_CATEGORIES, ...customTabs].map(cat => (
              <button
                key={cat}
                style={{ ...styles.categoryPill, ...(cat === category ? styles.categoryPillActive : {}) }}
                onClick={() => changeCategory(cat)}
              >
                {cat.charAt(0).toUpperCase() + cat.slice(1)}
              </button>
            ))}
            <button style={styles.categoryCancel} onClick={() => setShowCategoryPicker(false)}>✕</button>
          </div>
        ) : (
          <button style={styles.categoryValue} onClick={() => setShowCategoryPicker(true)}>
            {category.charAt(0).toUpperCase() + category.slice(1)} ›
          </button>
        )}
      </div>

      <div style={styles.sourceRow}>
        <span style={styles.sourceIcon}>🔗</span>
        {editingUrl ? (
          <>
            <input
              style={styles.urlInput}
              value={urlInput}
              onChange={e => setUrlInput(e.target.value)}
              placeholder="Paste a recipe URL…"
              type="url"
              autoFocus
            />
            <button style={styles.urlSaveBtn} onClick={saveUrl}>Save</button>
            <button style={styles.urlCancelBtn} onClick={() => { setUrlInput(bundle.source_url || ''); setEditingUrl(false) }}>✕</button>
          </>
        ) : urlInput ? (
          <>
            <a href={urlInput} target="_blank" rel="noopener noreferrer" style={styles.sourceLink}>
              {urlInput.replace(/^https?:\/\//, '').split('/')[0]}
            </a>
            <button style={styles.urlEditBtn} onClick={() => setEditingUrl(true)}>Edit</button>
          </>
        ) : (
          <button style={styles.urlAddBtn} onClick={() => setEditingUrl(true)}>Add recipe URL</button>
        )}
      </div>

      <div style={styles.hintRow}>
        <span style={styles.hintText}>Tap item to uncheck · swipe or tap X to remove</span>
      </div>

      <div style={styles.content}>
        {loading ? (
          <div style={styles.loading}>Loading items...</div>
        ) : editingOrder ? (
          getSortedItems().map((item, idx, sorted) => {
            const cat = getGroceryCategory(item)
            const prevCat = idx > 0 ? getGroceryCategory(sorted[idx - 1]) : null
            return (
              <div key={item.id}>
                {cat !== prevCat && <div style={styles.categoryHeader}>{cat}</div>}
                <div style={styles.reorderRow}>
                  <span style={styles.reorderEmoji}>{getItemEmoji(item)}</span>
                  <div style={styles.reorderInfo}>
                    <div style={styles.reorderName}>{item.name}</div>
                    {item.size ? <div style={styles.reorderSub}>{item.size}</div> : null}
                  </div>
                  <div style={styles.reorderBtns}>
                    <button style={styles.arrowBtn} onClick={() => moveBundleItem(item, -1)} disabled={idx === 0}>↑</button>
                    <button style={styles.arrowBtn} onClick={() => moveBundleItem(item, 1)} disabled={idx === sorted.length - 1}>↓</button>
                  </div>
                </div>
              </div>
            )
          })
        ) : (
          getSortedItems().map((item, idx, sorted) => {
            const cat = getGroceryCategory(item)
            const prevCat = idx > 0 ? getGroceryCategory(sorted[idx - 1]) : null
            return (
              <div key={item.id}>
                {cat !== prevCat && <div style={styles.categoryHeader}>{cat}</div>}
                <div style={styles.itemRow}>
                  <div
                    style={{ ...styles.checkbox, ...(checked[item.id] ? styles.checkboxOn : styles.checkboxOff) }}
                    onClick={() => toggleCheck(item.id)}
                  >
                    {checked[item.id] && (
                      <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
                        <path d="M1.5 5.5l3 3 5-5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    )}
                  </div>
                  <button
                    style={styles.itemImg}
                    onClick={() => setEmojiPickerItem(prev => prev === item.id ? null : item.id)}
                    title="Change emoji"
                  >
                    <span style={{ fontSize: '19px' }}>{getItemEmoji(item)}</span>
                  </button>
                  <div style={styles.itemInfo} onClick={() => toggleCheck(item.id)}>
                    <div style={styles.itemBrand}>{item.brand}</div>
                    <div style={styles.itemName}>{item.name}</div>
                    <div style={styles.itemSize}>{item.size}</div>
                  </div>
                  <div style={styles.itemRight}>
                    <div style={styles.qtyControl} onClick={e => e.stopPropagation()}>
                      <button style={styles.qtyBtn} onClick={() => updateQuantity(item.id, -1)}>−</button>
                      <span style={styles.qtyNum}>{item.quantity || 1}</span>
                      <button style={styles.qtyBtn} onClick={() => updateQuantity(item.id, 1)}>+</button>
                    </div>
                    <div style={styles.itemPrice}>${((item.price || 0) * (item.quantity || 1)).toFixed(2)}</div>
                    <button style={styles.deleteBtn} onClick={() => deleteItem(item.id)}>X</button>
                  </div>
                </div>
                {emojiPickerItem === item.id && (
                  <div style={styles.emojiPicker}>
                    {ITEM_EMOJIS.map(e => (
                      <button key={e} style={styles.emojiOption} onClick={() => changeItemEmoji(item.id, e)}>{e}</button>
                    ))}
                  </div>
                )}
              </div>
            )
          })
        )}

        {!editingOrder && showSearch ? (
          <div style={styles.searchSection}>
            <div style={styles.searchRow}>
              <input
                style={styles.searchInput}
                placeholder="Search products..."
                value={search}
                autoFocus
                onChange={e => {
                  setSearch(e.target.value)
                  searchKroger(e.target.value)
                }}
              />
              {search.length > 1 && (
                <button style={styles.resultAdd} onClick={() => addItem({ name: search, brand: 'Manual', size: '', price: 0, emoji: '🛒' })}>+</button>
              )}
              <button style={styles.cancelSearch} onClick={() => { setShowSearch(false); setSearch(''); setSearchResults([]) }}>
                Cancel
              </button>
            </div>
            {search.length > 1 && (
  <div style={styles.resultRow} onClick={() => addItem({ name: search, brand: 'Manual', size: '', price: 0, emoji: '🛒' })}>
    <div style={styles.resultInfo}>
      <div style={styles.resultName}>Add "{search}"</div>
      <div style={styles.resultMeta}>Add as a manual item</div>
    </div>
    <button style={styles.resultAdd}>+</button>
  </div>
)}
{searching && <div style={styles.searchingText}>Searching...</div>}
{searchResults.map((item, i) => (
  <div key={i} style={styles.resultRow} onClick={() => addItem(item)}>
    <div style={styles.resultInfo}>
      <div style={styles.resultName}>{item.name}</div>
      <div style={styles.resultMeta}>{item.brand} · {item.size}</div>
    </div>
    <div style={styles.resultPrice}>${item.price?.toFixed(2)}</div>
    <button style={styles.resultAdd}>+</button>
  </div>
))}

          </div>
        ) : !editingOrder ? (
          <div style={styles.addRow} onClick={() => setShowSearch(true)}>
            <div style={styles.addCircle}>+</div>
            <span style={styles.addLabel}>Add an item</span>
          </div>
        ) : null}
      </div>

      <button style={styles.cartBar} onClick={addToCart}>
        <div>
          <div style={styles.cartMain}>Add to cart</div>
          <div style={styles.cartSub}>
            {checkedItems.length} item{checkedItems.length !== 1 ? 's' : ''} · ${total.toFixed(2)}
          </div>
        </div>
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path d="M4 9h10M10 5l4 4-4 4" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
    </div>
  )
}

const styles = {
  container: {
    maxWidth: '430px', margin: '0 auto', minHeight: '100vh',
    background: 'white', display: 'flex', flexDirection: 'column',
    fontFamily: "'DM Sans', sans-serif",
  },
  navBar: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    padding: '12px 20px 10px', flexShrink: 0,
  },
  backBtn: {
    fontSize: '13px', color: '#1D9E75', background: 'none',
    border: 'none', cursor: 'pointer', fontFamily: "'DM Sans', sans-serif",
  },
  deleteBundleBtn: {
    fontSize: '12px', fontWeight: '500', color: '#C0392B',
    background: 'none', border: 'none', cursor: 'pointer',
    fontFamily: "'DM Sans', sans-serif",
  },
  checkAllBtn: {
    fontSize: '12px', color: '#1D9E75', background: 'none',
    border: 'none', cursor: 'pointer', fontFamily: "'DM Sans', sans-serif",
  },
  hero: {
    margin: '0 20px 12px', padding: '14px 16px', borderRadius: '16px',
    display: 'flex', alignItems: 'center', gap: '12px', flexShrink: 0,
  },
  heroEmojiBtn: {
    fontSize: '32px', background: 'none', border: 'none',
    cursor: 'pointer', padding: '0', lineHeight: '1',
  },
  bundleEmojiPicker: {
    display: 'flex', flexWrap: 'wrap', gap: '2px',
    padding: '10px', margin: '0 20px 8px',
    background: 'white', border: '0.5px solid #eee',
    borderRadius: '14px', boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
  },
  bundleEmojiOption: {
    width: '36px', height: '36px', fontSize: '20px',
    background: 'none', border: 'none', borderRadius: '8px',
    cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  bundleEmojiOptionActive: { background: '#E1F5EE' },
  heroName: { fontFamily: "'DM Serif Display', serif", fontSize: '20px', color: '#1a1a18', marginBottom: '2px' },
  heroMeta: { fontSize: '11px', color: '#888' },
  hintRow: { padding: '0 20px 8px', flexShrink: 0 },
  categoryRow: {
    display: 'flex', alignItems: 'center', gap: '8px',
    padding: '8px 20px', flexShrink: 0,
  },
  categoryLabel: { fontSize: '12px', color: '#aaa' },
  categoryValue: {
    background: 'none', border: 'none', fontSize: '12px', color: '#1D9E75',
    cursor: 'pointer', fontFamily: "'DM Sans', sans-serif", padding: '0',
  },
  categoryPills: { display: 'flex', flexWrap: 'wrap', gap: '6px', alignItems: 'center' },
  categoryPill: {
    padding: '4px 10px', borderRadius: '20px', border: '0.5px solid #ddd',
    background: '#f9f9f7', fontSize: '12px', cursor: 'pointer',
    fontFamily: "'DM Sans', sans-serif", color: '#1a1a18',
  },
  categoryPillActive: { background: '#1D9E75', color: 'white', border: '0.5px solid #1D9E75' },
  categoryCancel: {
    background: 'none', border: 'none', fontSize: '14px', color: '#aaa',
    cursor: 'pointer', fontFamily: "'DM Sans', sans-serif", padding: '0',
  },
  sourceRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '0 20px 8px',
    flexShrink: 0,
  },
  sourceIcon: { fontSize: '13px' },
  sourceLink: {
    fontSize: '12px',
    color: '#1D9E75',
    textDecoration: 'none',
    fontFamily: "'DM Sans', sans-serif",
    borderBottom: '0.5px solid #1D9E75',
  },
  urlInput: {
    flex: 1, padding: '6px 10px', borderRadius: '8px',
    border: '0.5px solid #1D9E75', outline: 'none',
    fontFamily: "'DM Sans', sans-serif", fontSize: '12px', color: '#1a1a18',
    background: '#f9f9f7',
  },
  urlSaveBtn: {
    flexShrink: 0, padding: '5px 10px', borderRadius: '8px',
    background: '#1D9E75', border: 'none', color: 'white',
    fontFamily: "'DM Sans', sans-serif", fontSize: '12px', cursor: 'pointer',
  },
  urlCancelBtn: {
    flexShrink: 0, background: 'none', border: 'none',
    fontSize: '13px', color: '#aaa', cursor: 'pointer', padding: '0 2px',
  },
  urlEditBtn: {
    flexShrink: 0, background: 'none', border: 'none',
    fontSize: '12px', color: '#aaa', cursor: 'pointer', padding: '0',
    fontFamily: "'DM Sans', sans-serif", textDecoration: 'underline',
  },
  urlAddBtn: {
    background: 'none', border: 'none', padding: '0',
    fontSize: '12px', color: '#aaa', cursor: 'pointer',
    fontFamily: "'DM Sans', sans-serif", textDecoration: 'underline',
  },
  hintText: { fontSize: '11px', color: '#aaa' },
  content: { flex: 1, overflowY: 'auto', padding: '0 20px 8px' },
  categoryHeader: {
    fontSize: '10px', fontWeight: '600', color: '#aaa',
    textTransform: 'uppercase', letterSpacing: '0.08em',
    padding: '10px 0 4px', borderBottom: '0.5px solid #eee', marginBottom: '2px',
  },
  loading: { color: '#aaa', fontSize: '13px', padding: '20px 0' },
  itemRow: {
    display: 'flex', alignItems: 'center', gap: '10px',
    padding: '9px 0', borderBottom: '0.5px solid #eee',
  },
  checkbox: {
    width: '20px', height: '20px', borderRadius: '6px',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    flexShrink: 0, cursor: 'pointer',
  },
  checkboxOn: { background: '#1D9E75', border: '1.5px solid #1D9E75' },
  checkboxOff: { background: 'white', border: '1.5px solid #ddd' },
  itemImg: {
    width: '38px', height: '38px', borderRadius: '9px',
    background: '#f9f9f7', border: '0.5px solid #eee',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    flexShrink: 0, cursor: 'pointer',
  },
  emojiPicker: {
    display: 'flex', flexWrap: 'wrap', gap: '2px',
    padding: '8px', background: '#f9f9f7',
    border: '0.5px solid #eee', borderRadius: '12px',
    marginBottom: '4px',
  },
  emojiOption: {
    width: '34px', height: '34px', fontSize: '18px',
    background: 'none', border: 'none', borderRadius: '8px',
    cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  itemInfo: { flex: 1, minWidth: 0, cursor: 'pointer' },
  itemBrand: { fontSize: '10px', color: '#aaa', textTransform: 'uppercase', letterSpacing: '0.04em' },
  itemName: { fontSize: '13px', fontWeight: '500', color: '#1a1a18' },
  itemSize: { fontSize: '11px', color: '#888' },
  itemRight: { display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 },
  qtyControl: { display: 'flex', alignItems: 'center', gap: '4px' },
  qtyBtn: {
    width: '22px', height: '22px', borderRadius: '6px', border: '0.5px solid #ddd',
    background: '#f9f9f7', fontSize: '14px', cursor: 'pointer', display: 'flex',
    alignItems: 'center', justifyContent: 'center', color: '#1a1a18', fontFamily: "'DM Sans', sans-serif",
  },
  qtyNum: { fontSize: '13px', fontWeight: '500', color: '#1a1a18', minWidth: '16px', textAlign: 'center' },
  itemPrice: { fontSize: '12px', color: '#888' },
  deleteBtn: {
    width: '24px', height: '24px', borderRadius: '6px',
    border: '0.5px solid #F09595', background: '#FCEBEB',
    color: '#A32D2D', fontSize: '11px', cursor: 'pointer',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontFamily: "'DM Sans', sans-serif",
  },
  addRow: {
    display: 'flex', alignItems: 'center', gap: '10px',
    padding: '11px 0', cursor: 'pointer',
    borderTop: '0.5px solid #eee', marginTop: '4px',
  },
  addCircle: {
    width: '28px', height: '28px', borderRadius: '8px',
    border: '1.5px dashed #1D9E75',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    color: '#1D9E75', fontSize: '18px', flexShrink: 0,
  },
  addLabel: { fontSize: '13px', color: '#1D9E75', fontWeight: '500' },
  searchSection: { marginTop: '8px' },
  searchRow: {
    display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '8px',
  },
  searchInput: {
    flex: 1, padding: '10px 12px',
    border: '0.5px solid #1D9E75', borderRadius: '10px',
    fontFamily: "'DM Sans', sans-serif", fontSize: '14px',
    color: '#1a1a18', background: 'white', outline: 'none',
  },
  cancelSearch: {
    fontSize: '13px', color: '#888', background: 'none',
    border: 'none', cursor: 'pointer', fontFamily: "'DM Sans', sans-serif",
    whiteSpace: 'nowrap',
  },
  searchingText: { fontSize: '12px', color: '#aaa', padding: '8px 0' },
  resultRow: {
    display: 'flex', alignItems: 'center', gap: '10px',
    padding: '10px 0', borderBottom: '0.5px solid #eee', cursor: 'pointer',
  },
  resultInfo: { flex: 1, minWidth: 0 },
  resultName: { fontSize: '13px', fontWeight: '500', color: '#1a1a18', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
  resultMeta: { fontSize: '11px', color: '#888' },
  resultPrice: { fontSize: '13px', fontWeight: '500', color: '#1a1a18', flexShrink: 0 },
  resultAdd: {
    width: '26px', height: '26px', borderRadius: '50%',
    border: '0.5px solid #ddd', background: '#f9f9f7',
    fontSize: '16px', color: '#888', cursor: 'pointer', flexShrink: 0,
  },
  reorderRow: {
    display: 'flex', alignItems: 'center', gap: '10px',
    padding: '10px 0', borderBottom: '0.5px solid #eee',
  },
  reorderEmoji: { fontSize: '20px', width: '28px', textAlign: 'center', flexShrink: 0 },
  reorderInfo: { flex: 1, minWidth: 0 },
  reorderName: { fontSize: '13px', fontWeight: '500', color: '#1a1a18' },
  reorderSub: { fontSize: '11px', color: '#888', marginTop: '1px' },
  reorderBtns: { display: 'flex', gap: '4px', flexShrink: 0 },
  arrowBtn: {
    width: '28px', height: '28px', borderRadius: '8px',
    border: '0.5px solid #ddd', background: '#f9f9f7',
    fontSize: '14px', cursor: 'pointer', color: '#1a1a18',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  cartBar: {
    margin: '6px 20px 14px', padding: '12px 18px',
    background: '#1D9E75', borderRadius: '14px',
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    cursor: 'pointer', flexShrink: 0, border: 'none', width: 'calc(100% - 40px)',
  },
  cartMain: { fontSize: '13px', fontWeight: '500', color: 'white' },
  cartSub: { fontSize: '11px', color: 'rgba(255,255,255,0.8)' },
}